<!--
input校验组件
引入本组件 在页面上调用
示例： <input-validate  v-model="goods" type="float" maxlength="20"></input-validate>
v-model 绑定值
type  指要限制的类型 int（正数） float（带小数的数）money（金额）
maxlength 限制长度 默认50
:disabled 是否禁用
-->
<template>
  <div class="el-input el-input--medium" :class="disabled ? 'is-disabled' : ''">
    <input
      type="text"
      :name="type"
      :maxlength="maxlength"
      rows="2"
      class="el-input__inner"
      :disabled="disabled"
      ref="validateInput"
      v-bind:value="value"
      v-on:input="updateValue"
    >
  </div>
</template>
<script>
// 递归删除输入长度直至匹配正确，防止输入多次来不及删除
function tryTest (testVal, reg) {
  if (!testVal.match(reg) && testVal.length > 1) {
    return tryTest(testVal.substring(0, testVal.length - 1), reg)
  } else if (!testVal.match(reg) && testVal.length === 1) {
    return ''
  } else {
    return testVal
  }
}
var currencyValidator = {
  money: function (str, _this) {
    const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^[1-9](\d+)?(\.)?$)|(^(0){1}$)|(^\d\.\d{0,2}?$)/g
    var val = str
    if (val && !reg.test(val)) {
      var initVal = val
      val = tryTest(initVal, reg)
      msg && msg.close()
      msg = _this.$message.error('请输入正确的金额')
      window.time = Date.now()
    }
    console.log(val)
    return val
  },
  // 整数
  intNum: function (value, _this) {
    if (value && !/^[0-9]*$/.test(value)) {
      msg && msg.close()
      msg = _this.$message.error('请输入正确的整数')
    }
    return value.replace(/\D/g, '')
  },
  // 手机号码
  phone: function (value, _this) {
    // let isMobile = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/
    let isMobile = /^((1[3-9]{1}[0-9]{1})+\d{8})$/ // 增加了16+ 和 19+ 网段
    if (value && !isMobile.test(value)) {
      msg && msg.close()
      msg = _this.$message.error('请输入正确的手机号码')
    }
    return ''
  },
  // 电子邮箱
  email: function (value) {
    let isEmail = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
    return isEmail.test(value)
  },
  digit: function (value) {
    if (Number.isNaN(value)) {
      console.log('请输入正确的')
    }
    if (!value || !/\d/g.test(value)) {
      return ''
    } else if (value.indexOf('.') > -1) {
      // 将多个小数点替换成一个小数点
      return value.replace(/\.+/, '.')
    } else {
      return parseFloat(value)
    }
  }
}
var msg
export default {
  name: 'InputValidate',
  props: {
    value: {
      default: ''
    },
    type: {
      default: Number
    },
    maxlength: {
      default: 50
    },
    disabled: {
      default: false
    }
  },
  methods: {
    updateValue: function () {
      const value = event.currentTarget.value
      const _this = this
      let result
      switch (event.currentTarget.name) {
        case 'int':
          result = currencyValidator.intNum(value, _this)
          break
        case 'float':
          result = currencyValidator.digit(value, _this)
          break
        case 'money': // 金额
          result = currencyValidator.money(value, _this)
          break
        default:
          result = currencyValidator.intNum(value, _this)
          break
      }
      _this.$refs.validateInput.value = result
      _this.$emit('input', result)
    }
  }
}
</script>
